import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';
import { getPendingState } from 'utils/get-pending-state';
import { ILoyaltyRewardValue } from '../types';
import { getCookies } from 'common/selectors';
import { SHOPPING_LIST_COOKIE_KEY } from 'common/constants';

const featureRootSelector = createFeatureSelector('products');

export const getRatings = createSelector(featureRootSelector, ({ ratings }) => ratings);

export const getRatingsState = createSelector(getRatings, ({ data, isFetching, error }) =>
  getPendingState({
    data,
    pending: isFetching,
    error,
  }),
);

export const getRatingsData = createSelector(getRatings, ({ data }) => data);

export const getRatingsError = createSelector(getRatings, ({ error }) => error);

export const getProductsByIds = createSelector(featureRootSelector, ({ productsByIds }) => productsByIds);

export const getProductsByIdsState = createSelector(getProductsByIds, ({ data, isFetching, error }) =>
  getPendingState({
    data,
    pending: isFetching,
    error,
  }),
);

export const getProductsByIdsData = createSelector(getProductsByIds, ({ data }) => data);

export const getProductsByIdsError = createSelector(getProductsByIds, ({ error }) => error);

export const getSponsoredProducts = createSelector(
  featureRootSelector,
  ({ sponsoredProducts }) => sponsoredProducts,
);

export const getSponsoredProductsState = createSelector(
  getSponsoredProducts,
  ({ data, isFetching, error }) =>
    getPendingState({
      data,
      pending: isFetching,
      error,
    }),
);

export const getSponsoredProductsData = createSelector(getSponsoredProducts, ({ data }) => data);

export const getSponsoredProductsError = createSelector(getSponsoredProducts, ({ error }) => error);

const emptyLoyaltyRewards: ILoyaltyRewardValue = {};

export const getLoyaltyRewards = createSelector(
  featureRootSelector,
  ({ loyaltyRewards }) => loyaltyRewards.data || emptyLoyaltyRewards,
);

export const getProductsData = createSelector(
  featureRootSelector,
  ({ productsByIds, sponsoredProducts }) => sponsoredProducts?.data ?? productsByIds?.data,
);

export const getIsFallback = createSelector(featureRootSelector, ({ isFallback }) => isFallback);

export const getShoppingListCookie = createSelector(
  getCookies,
  (cookies) => cookies?.[SHOPPING_LIST_COOKIE_KEY] as string | undefined,
);
